import * as helper from "../../helpers/user_management_helpers";

import {
  getUserListforReportTo,
  routingProfile,
  skillList,
} from "../../api/helperspi/user_helperapi";

import { USER_HELPER } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
  routingProfileData: [] as any,
  skillData: [] as any,
  userListByrole: [] as any,
  userListByrole_sup: [] as any,
};

const allUserhelperSlice = createSlice({
  name: USER_HELPER,
  initialState,
  reducers: {
    reset: () => {},
  },
  extraReducers: (builder) => {
    builder.addCase(routingProfile.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        helper.mapResponseDataToroutingProfileData(
          state,
          payload.data.getRoutingListRes
        );
      }
    });
    builder.addCase(skillList.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        helper.mapResponseDataToSkillData(
          state,
          payload.data.getSkillNumberlist
        );
      }
    });
    builder.addCase(getUserListforReportTo.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode === 200) {
        helper.mapResponseDataToreportToData(
          state,
          payload.data.getUserListByRoleId
        );
      }
    });
  },
});
export const AllUserHelperActions = allUserhelperSlice.actions;
export default allUserhelperSlice.reducer;
